import {
  Box,
  Checkbox,
  Chip,
  FormControlLabel,
  TextField,
} from "@material-ui/core";

const extensionDaysOptions = [
  { label: "10 dias", value: 10 },
  { label: "30 dias", value: 30 },
  { label: "90 dias", value: 90 },
  { label: "6 meses", value: 183 },
  { label: "1 ano", value: 365 },
];

export default function ExtensionDaysInput({
  extensionDays,
  errorMessage,
  isLifetime,
  onChangeIsLifetime = () => null,
  onChangeExtensionDays = () => null,
}) {
  return (
    <Box width="100%">
      {!isLifetime && (
        <>
          <TextField
            fullWidth
            variant="outlined"
            label="Nova validade (em dias)"
            placeholder="Ex: 30"
            type="number"
            inputProps={{
              min: 0,
            }}
            InputLabelProps={{
              shrink: true,
            }}
            value={extensionDays}
            onChange={(e) => onChangeExtensionDays(e.target.value)}
            error={!!errorMessage}
            helperText={errorMessage}
          />
          <Box
            marginTop="0.5rem"
            marginBottom="1rem"
            display="flex"
            gridColumnGap="0.75rem"
          >
            {extensionDaysOptions.map((extensionDay) => (
              <Chip
                size="small"
                variant="outline"
                label={extensionDay.label}
                onClick={() => onChangeExtensionDays(extensionDay.value)}
              />
            ))}
          </Box>
        </>
      )}
      <FormControlLabel
        label="Acesso vitalício"
        control={
          <Checkbox
            color="primary"
            checked={isLifetime}
            onChange={(_, checked) => onChangeIsLifetime(checked)}
          />
        }
      />
    </Box>
  );
}
